module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Glass-martini-ada42e1d657b7d4d4433b8e8189f3887.svg";